<template>
    <v-container fluid >
        <v-row no-gutters class="d-block">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                    <!-- Botones y búsqueda zona superior -->
                    <v-card-title>
                        <v-row>
                            <v-col cols="6" sm="3" md="3" lg="3" xl="3">
                                <v-btn color="success" small v-if="permisos[2]" outlined @click="firmasNuevo()">
                                    <v-icon>add</v-icon>
                                    Nuevo
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="3" md="3" lg="3" xl="3">
                                <v-btn color="info" small outlined @click="firmasGet()">
                                    <v-icon>refresh</v-icon>
                                    Refrescar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" md="2" class="pt-0">
                                <v-select
                                    hide-details clearable
                                    v-model="categoria"
                                    :items="categorias"
                                    item-text="texto"
                                    item-value="valor"
                                    label="Categoría"
                                    @change="firmasBuscar()"
                                />
                            </v-col>
                            <v-col cols="12" sm="6" md="2" class="pt-0">
                                <v-select
                                    hide-details clearable
                                    v-model="sedeId"
                                    :items="sedes"
                                    item-text="nombre"
                                    item-value="sede_id"
                                    label="Sede"
                                    @change="firmasBuscar()"
                                />
                            </v-col>
                            <v-col cols="12" sm="6" md="2" class="pt-0">
                                <v-select
                                    hide-details clearable
                                    v-model="departamentoId"
                                    :items="departamentos"
                                    item-text="nombre"
                                    item-value="departamento_id"
                                    label="Departamento"
                                    @change="firmasBuscar()"
                                />
                            </v-col>
                            <v-col cols="12" sm="6" md="4" class="pt-0">
                                <v-text-field
                                    v-model="search"
                                    hide-details
                                    label="Buscar por nombre o identidad."
                                    clearable>
                                    <template v-slot:append>
                                        <v-btn
                                            color="secondary" small outlined
                                            @click="firmasBuscar()">
                                            <v-icon>search</v-icon>
                                        </v-btn>
                                    </template>
                                    ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <!-- Lista de firmas -->
                    <v-card-text>
                        <v-data-table
                            dense
                            class="elevation-3"
                            :headers="tableHeaders"
                            :items="firmas"
                            :loading="loading" :disabled="loading"
                            item-key="persona_id"
                            fixed-header
                            height="65vh"
                            :hide-default-footer="true"
                            disable-pagination
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-center celda-firma">
                                        <img v-if="item.firma_url" :src="item.firma_url" :alt="'Firma de ' + item.nombre" loading="lazy">
                                    </td>
                                    <td class="text-left">
                                        {{ item.nombre }} {{ item.apellido }}
                                        <div class="text-caption grey--text text--darken-1">
                                            <span v-if="item.numero_identidad">{{ item.numero_identidad }}</span>
                                            <span v-else class="warning--text">Sin identidad</span>
                                            <span v-if="item.sede"> · {{ item.sede }}</span>
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <v-chip x-small label text-color="white" :color="colorCategoria(item.categoria)" v-if="item.categoria_texto">
                                            {{ item.categoria_texto }}
                                        </v-chip>
                                        <span v-else class="grey--text">—</span>
                                    </td>
                                    <td class="text-left">
                                        <span v-if="item.departamento">{{ item.departamento }}</span>
                                        <span v-else class="warning--text text-caption" title="Edite la firma para indicar su departamento o unidad">Sin indicar</span>
                                    </td>
                                    <td class="text-left text-no-wrap">{{ item.fecha_registro | fechaESP }}</td>
                                    <td class="text-center">
                                        <v-chip x-small label outlined :color="item.activo ? 'success' : 'grey'">
                                            {{ item.activo ? 'Activa' : 'Inactiva' }}
                                        </v-chip>
                                    </td>
                                    <td class="text-center">
                                        <v-btn color="info" small outlined @click="firmasEdit(item)" title="Editar" v-if="permisos[3]">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn color="error" small outlined class="ml-1" @click="eliminarAbrir(item)" title="Eliminar" v-if="permisos[4]">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
                                <v-alert dense type="warning" outlined class="text-center mt-3">
                                    No existen registros de firmas.
                                </v-alert>
                            </template>
                        </v-data-table>
                        <Pagination :pagination="pagination" @setCambiarPagina="setCambiarPagina" v-if="pagination.total"/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Eliminación con doble confirmación: código generado + justificación -->
        <v-dialog v-model="eliminar.dialogo" max-width="520" persistent>
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    <v-icon left color="error">delete_forever</v-icon> Eliminar firma
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="eliminar.dialogo = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text v-if="eliminar.firma">
                    <p class="mb-2">Va a eliminar la firma de <b>{{ eliminar.firma.nombre }} {{ eliminar.firma.apellido }}</b>. Esta acción queda registrada con su usuario, la fecha y la justificación.</p>
                    <v-alert dense text type="warning" class="mb-3" v-if="eliminar.codigo">
                        Para confirmar, escriba este código: <b class="text-h6">{{ eliminar.codigo }}</b>
                        <div class="text-caption">Vence en {{ eliminar.minutos }} minutos.</div>
                    </v-alert>
                    <v-text-field v-model="eliminar.codigoEscrito" label="Código de confirmación" outlined dense maxlength="6"
                                  :disabled="!eliminar.codigo" prepend-inner-icon="pin"/>
                    <v-textarea v-model="eliminar.motivo" label="Justificación (obligatoria)" outlined dense rows="3" auto-grow maxlength="500" counter
                                :disabled="!eliminar.codigo" prepend-inner-icon="notes" placeholder="Ej. La persona ya no labora en INFOP."/>
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="eliminar.dialogo = false">Cancelar</v-btn>
                    <v-btn color="error" depressed :loading="eliminar.cargando"
                           :disabled="!eliminar.codigo || eliminar.codigoEscrito.trim().toUpperCase() !== eliminar.codigo || eliminar.motivo.trim().length < 10"
                           @click="eliminarConfirmar">
                        Eliminar definitivamente
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Auth from "@/services/auth";
import Pagination from"@/pages/Components/Pagination.vue";

export default {
    //name: 'FirmasLista',
    name: 'AdministracionFirmas',
    components: {Pagination},
    data() {
        return {
            permisos: [],
            firmas: [],
            search: "",
            categoria: null,
            categorias: [
                {valor: "instructor", texto: "Instructor"},
                {valor: "jefe_departamento", texto: "Jefe de departamento"},
                {valor: "director", texto: "Director"},
                {valor: "encargado", texto: "Encargado"},
            ],
            sedeId: null,
            departamentoId: null,
            sedes: [],
            departamentos: [],
            eliminar: {dialogo: false, firma: null, codigo: null, minutos: 10, codigoEscrito: "", motivo: "", cargando: false},
            pagination: {},
            pageActual: 1,
            rowsPage: this.$store.state.arrayRowsPages[0],
            loading: false,
            tableHeaders: [
                {text: 'Firma', align: 'center', sortable: false, width: 150},
                {text: 'Nombre', value: 'nombre', align: 'left'},
                {text: 'Categoría', value: 'categoria', align: 'left'},
                {text: 'Departamento o unidad', value: 'departamento', align: 'left'},
                {text: 'Fecha de registro', value: 'fecha_registro', align: 'left'},
                {text: 'Estado', value: 'activo', align: 'center'},
                {text: 'Acciones', align: 'center', sortable: false},
            ],
        }
    },

    methods: {
        firmasNuevo() {
            this.$router.push({name: 'AdministracionFirmasNuevo'});
        },
        firmasBuscar() {
            this.pageActual = 1;
            this.firmasGet();
        },
        firmasGet() {
            this.loading = true;
            let params = {busqueda: this.search, filtros: {categoria: this.categoria || "", sede_id: this.sedeId || 0, departamento_id: this.departamentoId || 0}, page: this.pageActual, rowsPage: this.rowsPage};
            window.axios.get('/personas-administrativas', {params}).then(response => {
                if (response.data.success) {
                    let data = response.data.data;
                    this.firmas = data.personasAdministrativas.data;
                    this.pagination = data.pagination;
                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        colorCategoria(categoria) {
            return {director: "primary", jefe_departamento: "info", instructor: "secondary", encargado: "teal"}[categoria] || "grey";
        },
        catalogosGet() {
            window.axios.get('/catalogos/opciones').then(response => {
                if (response.data.success) {
                    this.sedes = response.data.data.sedes || [];
                    this.departamentos = response.data.data.departamentos || [];
                }
            }).catch(() => {});
        },
        eliminarAbrir(firma) {
            this.eliminar = {dialogo: true, firma, codigo: null, minutos: 10, codigoEscrito: "", motivo: "", cargando: true};
            window.axios.post('/personas-administrativas/codigo_eliminacion', {persona_id: firma.persona_id}).then(response => {
                if (response.data.success) {
                    this.eliminar.codigo = response.data.data.codigo;
                    this.eliminar.minutos = response.data.data.minutos;
                } else {
                    this.$toast.error(response.data.message, {timeout: 12000});
                    this.eliminar.dialogo = false;
                }
            })
                .catch(error => {
                    const cuerpo = error.response && error.response.data;
                    this.$toast.error((cuerpo && cuerpo.message) || "No se pudo preparar la eliminación.", {timeout: 12000});
                    this.eliminar.dialogo = false;
                })
                .finally(() => {
                    this.eliminar.cargando = false;
                });
        },
        eliminarConfirmar() {
            this.eliminar.cargando = true;
            const datos = {persona_id: this.eliminar.firma.persona_id, codigo: this.eliminar.codigoEscrito.trim(), motivo: this.eliminar.motivo.trim()};
            window.axios.post('/personas-administrativas/eliminar', datos).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.eliminar.dialogo = false;
                    this.firmasGet();
                } else {
                    this.$toast.error(response.data.message, {timeout: 12000});
                }
            })
                .catch(error => {
                    const cuerpo = error.response && error.response.data;
                    this.$toast.error((cuerpo && cuerpo.message) || "No se pudo eliminar.", {timeout: 12000});
                })
                .finally(() => {
                    this.eliminar.cargando = false;
                });
        },
        firmasEdit(firma) {
            if (typeof firma == "object") {
                let token = window.btoa(firma.persona_id);
                this.$router.push({name: 'AdministracionFirmasEditar', query: {token}});
            } else {
                this.$toast.error("Parametro no valido.");
            }
        },
        setCambiarPagina(data) {
            this.pageActual = data.page;
            this.rowsPage = data.rowsPage;
            this.firmasGet();
        },
    },
    created() {
        Auth.checkPermisos(this.$route.path).then((res) => {
            this.permisos = res;
            this.firmasGet();
            this.catalogosGet();
        });
    }
}
</script>

<style>

</style>

<style scoped>
.celda-firma img {
    max-height: 38px;
    max-width: 130px;
    object-fit: contain;
    vertical-align: middle;
}
</style>
